<template>
	<div class="page-order page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">库存日志列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>库存管理</el-breadcrumb-item>
							<el-breadcrumb-item>库存日志列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="desk_number" label="所属店铺：">
						    <el-select size="small" filterable v-model="form_search.desk_number" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.desk_list"
						                :key="item.number"
						                :label="item.name"
						                :value="item.number">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item prop="stock_number" label="商品名称：">
						    <el-select size="small" filterable v-model="form_search.stock_number" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.stock_list"
						                :key="item.stock_number"
						                :label="item.name"
						                :value="item.stock_number">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item prop="work_number" label="工单编号：" style="margin-bottom: 0;">
						    <el-input v-model="form_search.work_number" size="small" placeholder="工单编号" clearable></el-input>
						</el-form-item>
						<el-form-item prop="type" label="工单类型：">
						    <el-select size="small" v-model="form_search.type" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.type_list"
						                :key="item.id"
						                :label="item.name"
						                :value="item.id">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item label="时间区间：">
						    <el-select v-model="form_search.lately_day" size="small" placeholder="请选择"  @change="changeSelect">
						        <el-option
						                v-for="item in init_data.time_list"
						                :key="item.id"
						                :label="item.name"
						                :value="item.id"
						        ></el-option>
						    </el-select>
						</el-form-item>
						<el-form-item label="创建时间：">
						    <el-date-picker
						            size="small"
						            clearable
						            v-model="create_range"
						            type="daterange"
						            range-separator="至"
						            start-placeholder="开始日期"
						            end-placeholder="结束日期"
						            value-format="yyyy-MM-dd">
						    </el-date-picker>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="work_number" align="center" label="工单编号" min-width="120">
							</el-table-column>
							<el-table-column prop="desk_number" align="center" label="店铺编码" min-width="80">
							</el-table-column>
							<el-table-column prop="stock_number" align="center" label="商品编码" min-width="80">
							</el-table-column>
							<el-table-column prop="desk_name" align="center" label="所属店铺" min-width="150">
							</el-table-column>
							<el-table-column prop="product_name" align="center" label="商品名称" min-width="120">
							</el-table-column>
							<el-table-column prop="type_name" align="center" label="工单类型" min-width="80">
							</el-table-column>
							<el-table-column prop="count" align="center" label="库存数量" min-width="80">
								<template slot-scope="scope">
								    <span>{{scope.row.count}}{{scope.row.count > 0 ? scope.row.unit : ''}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="amount" align="center" label="合计金额" min-width="100">
							</el-table-column>
							<el-table-column prop="admin_name" align="center" label="操作账号" min-width="80">
							</el-table-column>
							<el-table-column prop="worker_name" align="center" label="操作员工" min-width="80">
							</el-table-column>
							<el-table-column prop="m_time" align="center" label="完成时间" min-width="160">
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
				<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
					<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				create_range:'',
				init_data: {
					desk_list: [],
					stock_list: [],
					type_list: [],
					time_list:[{id:-1,name:'不限'},{id:7,name:'近7天'},{id:30,name:'近1个月'},{id:90,name:'近3个月'},{id:180,name:'近半年'}]
				},
				form_search: {
					stock_number: this.$route.query.stock_number == undefined ? '' : this.$route.query.stock_number,
					desk_number: this.$route.query.desk_number == undefined ? '' : this.$route.query.desk_number,
					work_number: this.$route.query.work_number == undefined ? '' : this.$route.query.work_number,
					type: -1,
					lately_day:-1,
					start_date:'',
					end_date:''
				},
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '库存列表';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			changeSelect(){
			    this.create_range = '';
			    this.form_search.start_date = '';
			    this.form_search.end_date = '';
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var desk_default = [{number:'', name: '全部'}];
				var stock_default = [{stock_number:'', name: '全部'}];
				var type_default = [{id: -1, name: '全部'}];
				this.$client.get('/adminapi/stocklog/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.init_data.desk_list = desk_default.concat(res.desk_name_list);
					_this.init_data.stock_list = stock_default.concat(res.stock_product_name_list);
					_this.init_data.type_list = type_default.concat(res.type_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal){
                //console.log(newVal);
                if(newVal){
                    this.form_search.lately_day = -1;
                }
                if(newVal == null){
                    this.form_search.start_date = '';
                    this.form_search.end_date = '';
                }else{
                    this.form_search.start_date = newVal[0];
                    this.form_search.end_date = newVal[1];
                }
            }
		}
	}
</script>
<style>

</style>
<style scoped>

</style>
